import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import LoadHeader from "./components/header";
import LoadHero from "./pages/hero";
import LoadAbout from "./pages/about";
import LoadSolutions from "./pages/solutions";
import LoadResearchAndDevelopment from "./pages/r-and-d";
import LoadTechnologies from "./pages/techologies";
import LoadContact from "./pages/contact";
import LoadPrivacyPolicy from "./pages/privacy-policy";
import LoadFooter from "./components/footer";

function LoadBaseWebsite() {
    return (
        <div className="flex flex-col">
            <LoadHero />
            <LoadAbout />
            <LoadSolutions />
            <LoadResearchAndDevelopment />
            <LoadTechnologies />
            <LoadContact />
        </div>
    )
}

function LoadHyperWorks() {
    return (
        <div className="flex flex-col">
            <LoadHeader />
            
            <Router>
                <Routes>
                    <Route path="/" element={<LoadBaseWebsite />} />
                    <Route path="/privacy-policy" element={<LoadPrivacyPolicy />} />
                </Routes>
            </Router>

            <LoadFooter />
        </div>
    )
}

export default LoadHyperWorks;